export const ToastsBasic = `
<div>
  <Toast>
    Aww yeah, you read a toast.
    <button type="button" className="close" data-dismiss="toast">
      <i className="modus-icon material-icons">close</i>
    </button>
  </Toast>
  <Toast className="toast-dark">
    Aww yeah, you read a dark toast.
    <button type="button" className="close" data-dismiss="toast">
      <i className="modus-icon material-icons">close</i>
    </button>
  </Toast>
  <Toast className="toast-primary">
    Aww yeah, you read a primary toast.
    <button type="button" className="close" data-dismiss="toast">
      <i className="modus-icon material-icons">close</i>
    </button>
  </Toast>
  <Toast className="toast-secondary">
    Aww yeah, you read a secondary toast.
    <button type="button" className="close" data-dismiss="toast">
      <i className="modus-icon material-icons">close</i>
    </button>
  </Toast>
  <Toast className="toast-danger">
    Aww yeah, you read a danger toast.
    <button type="button" className="close" data-dismiss="toast">
      <i className="modus-icon material-icons">close</i>
    </button>
  </Toast>
  <Toast className="toast-warning">
    Aww yeah, you read a warning toast.
    <button type="button" className="close" data-dismiss="toast">
      <i className="modus-icon material-icons">close</i>
    </button>
  </Toast>
  <Toast className="toast-success">
    Aww yeah, you read a success toast.
    <button type="button" className="close" data-dismiss="toast">
      <i className="modus-icon material-icons">close</i>
    </button>
  </Toast>
</div>
`
